import counts from './counts';

const root = {
	counts
};

export default root;
